import { MESSAGES } from 'src/modules/common/constants.ts';

export type ActuatorFormFields =
    'damper' |
    'areaOrDiameter' |
    'blade' |
    'roundDumper' |
    'crankArmLength' |
    'safety' |
    'air';

export const MapFieldToLabel: Record<ActuatorFormFields, string> = {
    air: MESSAGES.actuatorsUserInputAirflow,
    crankArmLength: MESSAGES.DamperCrankArmLength,
    blade: MESSAGES.DamperBladeType,
    roundDumper: MESSAGES.DamperBladeType,
    safety: MESSAGES.DamperSafetyFactor,
    damper: MESSAGES.DamperType,
    areaOrDiameter: MESSAGES.DamperArea,
};
